<template>
  <header class="site-header" :class="{ 'scrolled': scrolled }">
    <div class="header-bg"></div>
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/">
            <img src="../assets/logo.png" alt="Photo Enhancer Logo" class="logo-img" />
            <span class="logo-text">Photo Enhancer - AI Upscale</span>
          </router-link>
        </div>
        
        <nav class="main-nav" :class="{ 'active': mobileMenuOpen }">
          <ul class="nav-list">
            <li class="nav-item">
              <router-link to="/" class="nav-link">Home</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/services" class="nav-link">Services</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/about" class="nav-link">About</router-link>
            </li>
          </ul>
        </nav>
        
        <button class="mobile-menu-toggle" @click="toggleMobileMenu" :class="{ 'active': mobileMenuOpen }">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
      </div>
    </div>
    
    <!-- 添加遮罩层 -->
    <div class="menu-overlay" :class="{ 'active': mobileMenuOpen }" @click="closeMobileMenu"></div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  data() {
    return {
      scrolled: false,
      mobileMenuOpen: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      document.body.classList.toggle('no-scroll', this.mobileMenuOpen);
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.classList.remove('no-scroll');
    }
  }
}
</script>

<style lang="scss" scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: padding 0.3s ease;
  padding: 20px 0;
  
  /* 移除直接背景色，使用背景元素 */
  .header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(26, 26, 46, 0.95), rgba(53, 53, 102, 0.95));
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: -1;
    transition: background 0.3s ease;
  }
  
  &.scrolled {
    padding: 15px 0;
    
    .header-bg {
      background: rgba(255, 255, 255, 0.95);
    }
    
    .logo-text {
      color: var(--text-color);
    }
    
    .nav-link {
      color: var(--text-color);
      
      &:hover, &.router-link-active {
        color: var(--primary-color);
      }
    }
    
    .mobile-menu-toggle {
      .bar {
        background-color: var(--text-color);
      }
    }
  }
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  
  .logo {
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
    }
    
    .logo-img {
      height: 40px;
      margin-right: 12px;
    }
    
    .logo-text {
      font-size: 1.5rem;
      font-weight: 700;
      color: white;
      transition: color 0.3s ease;
      letter-spacing: 0.5px;
      display: inline-block;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }
  }
  
  .main-nav {
    .nav-list {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
    }
    
    .nav-item {
      margin-left: 30px;
      
      &:first-child {
        margin-left: 0;
      }
    }
    
    .nav-link {
      color: white;
      text-decoration: none;
      font-size: 1rem;
      font-weight: 600;
      transition: color 0.3s ease;
      padding: 5px 0;
      position: relative;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
      
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 2px;
        background-color: var(--primary-color);
        transition: width 0.3s ease;
      }
      
      &:hover, &.router-link-active {
        color: var(--primary-light);
        
        &::after {
          width: 100%;
        }
      }
    }
  }
  
  .mobile-menu-toggle {
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 21px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
    
    .bar {
      width: 100%;
      height: 3px;
      background-color: white;
      border-radius: 3px;
      transition: all 0.3s ease;
    }
  }
}

@media (max-width: 768px) {
  .site-header {
    padding: 15px 0;
    
    .header-bg {
      background: linear-gradient(to right, rgba(26, 26, 46, 0.95), rgba(53, 53, 102, 0.95));
    }
    
    .logo-text {
      color: white;
      font-size: 1.3rem;
    }
    
    .header-content {
      position: relative;
    }
    
    .mobile-menu-toggle {
      display: flex;
      
      .bar {
        background-color: white;
      }
      
      &.active {
        .bar:nth-child(1) {
          transform: translateY(9px) rotate(45deg);
        }
        
        .bar:nth-child(2) {
          opacity: 0;
        }
        
        .bar:nth-child(3) {
          transform: translateY(-9px) rotate(-45deg);
        }
      }
    }
    
    .main-nav {
      position: fixed;
      top: 0;
      right: -100%;
      width: 80%;
      max-width: 300px;
      height: 100vh;
      background-color: white;
      box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
      transition: right 0.3s ease;
      z-index: 1000;
      padding: 80px 30px 30px;
      overflow-y: auto;
      overflow-x: hidden;
      
      &.active {
        right: 0;
      }
      
      .nav-list {
        flex-direction: column;
      }
      
      .nav-item {
        margin: 0 0 20px;
      }
      
      .nav-link {
        color: var(--text-color);
        font-size: 1.2rem;
        display: block;
        padding: 10px 0;
        text-shadow: none;
        
        &::after {
          display: none;
        }
        
        &:hover, &.router-link-active {
          color: var(--primary-color);
        }
      }
    }
  }
}

/* 添加遮罩层样式 */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  
  &.active {
    opacity: 1;
    visibility: visible;
  }
}

/* 修复移动菜单溢出问题 */
.main-nav {
  &.active {
    right: 0;
    overflow-x: hidden; /* 防止水平溢出 */
  }
}
</style> 